import {Directive, ElementRef, HostListener, inject, Input} from '@angular/core';
import {TabsComponent} from '@shared/controls/tabs/tabs/tabs.component';

@Directive({
  selector: '[plTabHeader]',
  exportAs: 'tabHeader'
})
export class TabHeaderDirective {
  private tabs = inject(TabsComponent);
  private elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private active: boolean;

  @Input('plTabHeader') bodyName: string;

  @HostListener('click') click() {
    this.tabs.activateTab(this.bodyName);
  }

  setActive(v: boolean) {
    this.active = v;

    if (v) {
      this.elementRef.nativeElement.classList.add('active');
      this.elementRef.nativeElement.setAttribute('aria-selected', 'true');
    } else {
      this.elementRef.nativeElement.classList.remove('active');
      this.elementRef.nativeElement.setAttribute('aria-selected', 'false');
    }
  }

  focus() {
    this.elementRef.nativeElement.focus();
  }
}
